export const TOKEN_CYBER = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5Mb3AiOiJCb290Y2FtcCDEkMOgIE7hurVuZyAwNCIsIkhldEhhblN0cmluZyI6IjExLzA0LzIwMjMiLCJIZXRIYW5UaW1lIjoiMTY4MTE3MTIwMDAwMCIsIm5iZiI6MTY1MjYzNDAwMCwiZXhwIjoxNjgxMzE4ODAwfQ.gSqRPtAGanL6NGpTCUadxaDv8iCWNHz1-5NHHkRP43A';

export const DOMAIN = 'https://fiverrnew.cybersoft.edu.vn/api';
export const TOKEN = 'token';
export const USERLOGIN = 'userLogin';
export const JOB_ID = 'jobID';
export const JOB_INFO = 'job_Info';
export const JOB_TYPE = 'job_type';
export const JOB_IMG = 'job_image';
export const USER_ID = 'user_id';
export const USER_NAME = 'user_name';
export const USER_ROLE = 'user_role';
export const USER_AVATAR = 'user_avatar';
